// extracted by mini-css-extract-plugin
export default {"card":"Card_card__afNh2","cardContent":"Card_cardContent__w63eQ","cardTitle":"Card_cardTitle__wr3Tq","titleText":"Card_titleText__Q2mo3"};